import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';
import { useHistory } from 'react-router';
import { useLocale } from '../../../hooks/useLocale';
import { cn } from '../../../utils';

const ArrowBackIcon = () => {
  const history = useHistory();
  const { isArabic } = useLocale();
  return (
    <ChevronLeft
      onClick={() => history.goBack()}
      size={25}
      className={cn(
        'mt-0.5 text-secondary cursor-pointer hover:opacity-70 animated',
        isArabic && 'rotate-180'
      )}
    />
  );
};

export default ArrowBackIcon;

export const ArrowForwardIcon = ({ className }: { className?: string }) => {
  const history = useHistory();
  const { isEnglish } = useLocale();
  return (
    <ChevronRight
      onClick={() => history.goBack()}
      size={20}
      className={cn(
        'mt-0.5 text-secondary cursor-pointer hover:opacity-70 animated',
        !isEnglish && 'rotate-180',
        className
      )}
    />
  );
};
